import {
  ToggleButton,
  type ToggleButtonProps,
} from '@repo/design-system-kit/components/toggle-button/toggle-button';
import cx from 'clsx';
import styles from './toggle-button-recurrence.module.css';

interface ToggleButtonRecurrenceProps extends Omit<ToggleButtonProps, 'items'> {
  itemsSmall: ToggleButtonProps['items'];
  itemsLarge: ToggleButtonProps['items'];
}

export function ToggleButtonRecurrence({
  itemsSmall,
  itemsLarge,
  className,
  ...props
}: ToggleButtonRecurrenceProps): JSX.Element {
  return (
    <>
      <ToggleButton {...props} className={cx(className, styles.small)} items={itemsSmall} />
      <ToggleButton {...props} className={cx(className, styles.large)} items={itemsLarge} />
    </>
  );
}
